// extracted by mini-css-extract-plugin
export default {"modal":"RedirectModal_modal__wy6+0","overlay":"RedirectModal_overlay__eGI-S","title":"RedirectModal_title__2e7dT","message":"RedirectModal_message__YOaj6"};